import { AttributeBase, AttributeOptions } from './attribute-base';

export class TextboxAttribute extends AttributeBase<string> {
  public override controlType = 'textbox';
  public override type: string;
  public override options: string[] = [];

  constructor(options: AttributeOptions = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
